import {observable, action, computed} from 'mobx'
import {saveAs} from 'file-saver'
import {createTable, filterTable} from 'Utils'
import {notification} from 'antd'

export class Tables {
  @observable transactions
  @observable metrics
  @observable pnlByTicker
  @observable filter
  @observable selected

  constructor(rootStore) {
    this.rootStore = rootStore

    this.transactions = {
      loading: false,
      size: 1,
      count: 1,
      page: 1,
      data: [],
      table: []
    }
    this.metrics = {
      loading: false,
      size: 1,
      count: 1,
      page: 1,
      data: [],
      table: []
    }
    this.pnlByTicker = {
      loading: false,
      size: 0,
      count: 1,
      page: 1,
      data: []
    }
    this.filter = ''
    this.selected = ''
  }

  @computed get filteredTransactions() {
    return filterTable(this.transactions.table, this.filter)
  }

  @computed get filteredMetrics() {
    return filterTable(this.metrics.table, this.filter)
  }

  @computed get pnlTable() {
    let table = this.pnlByTicker.data.slice()
    table.map(row => {
      row.key = row.ticker
    })
    return table
  }

  @computed get filteredPnl() {
    return filterTable(this.pnlTable, this.filter)
  }

  @action toggleSelected(table) {
    if (this.selected === table) {
      this.selected = ''
    } else {
      this.selected = table
    }
  }

  @action filterTable(filter) {
    this.filter = filter.toString().toLowerCase()
  }

  @action fetchTable(table, id, page = 1, req = table) {
    if (this.rootStore.backtest.single.data.is_currently_running) {
      return setTimeout(() => this.fetchTable(table, id, page, req), 1000)
    }
    this[table].data = []
    this[table].page = page
    this[table].loading = true
    return this.rootStore.api.request(`sys/backtests/${id}/tables/${req}?page=${page}`, 'get'
    ).then(resObj => {
      this[table].loading = false
      this[table].count = resObj.count
      if(Array.isArray(resObj.results)) {
        if (page === 1) {
          this[table].size = resObj.results.length
        }
        this[table].data = resObj.results
        this[table].table = createTable(resObj.results, false)
      }
    }).catch((e) => {
      notification['error']({
        message: `Couldn't load ${table} table`,
        description: e.message || 'Unknown error'
      })
      this[table].loading = false
    })
  }

  @action fetchTransactions(id, page = 1) {
    return this.fetchTable('transactions', id, page)
  }

  @action fetchMetrics(id, page = 1) {
    return this.fetchTable('metrics', id, page)
  }

  @action fetchPnlByTicker(id, page = 1) {
    return this.fetchTable('pnlByTicker', id, page, 'pnl-by-tickers')
  }

  @action saveFile(table, id, format) {
    const options = {
      headers: this.rootStore.api.headers,
      method: 'GET'
    }
    fetch(`api/v1/sys/backtests/${id}/tables/${table}?export_as=${format}`, options)
      .then(res => res.blob())
      .then(blob => {
        saveAs(blob, `${table}.${format}`)
      })
      .catch((e) => {
        notification['error']({
          message: 'Failed to save file',
          description: e.meessage || 'Unknown error'
        })
      })
  }
}
